module.exports = __webpack_public_path__ + "img/Group3183.ceb7b104.png";